import { render, staticRenderFns } from "./TabTagging.vue?vue&type=template&id=02bbf9e8&"
import script from "./TabTagging.vue?vue&type=script&lang=js&"
export * from "./TabTagging.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports